import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LearnMore from 'app/scripts/components/common/learn-more';

export const HEADER_FONTS = Object.freeze({
  Small: 15,
  Medium: 18,
  Large: 24
});

class TitleAndDescription extends Component {
  static propTypes = {
    titleFont: PropTypes.oneOf([HEADER_FONTS.Large, HEADER_FONTS.Small, HEADER_FONTS.Medium]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    learnMoreModalRef: PropTypes.object
  };

  static defaultProps = {
    titleFont: HEADER_FONTS.Small
  };

  static displayName = 'TitleAndDescription';

  render() {
    let { titleFont, title, description } = this.props;
    let titleComponent = null,
      descriptionComponent = null;
    let learnMoreObject = null;

    if (typeof this.props.learnMoreModalRef === 'object') {
      learnMoreObject = <LearnMore onClick={this.openLearnMoreModel.bind(this)} />;
    }

    switch (titleFont) {
      case HEADER_FONTS.Large:
        titleComponent = (
          <h3>
            {title}
            {learnMoreObject}
          </h3>
        );
        break;
      case HEADER_FONTS.Small:
        titleComponent = (
          <h5>
            {title}
            {learnMoreObject}
          </h5>
        );
        break;
      case HEADER_FONTS.Medium:
        titleComponent = (
          <h4>
            {title}
            {learnMoreObject}
          </h4>
        );
        break;
    }

    descriptionComponent = <span className="description">{description}</span>;

    return (
      <div className="description-component">
        {titleComponent}
        {descriptionComponent}
      </div>
    );
  }

  openLearnMoreModel() {
    this.props.learnMoreModalRef.show();
  }
}

export default TitleAndDescription;
